import { useOverflowStatus } from '../../hooks/useOverflowStatus'
import { Item } from '../../models/Item'
import { Line } from '../../models/Line'
import Paragraph from '../app/design/Paragraph'
import Tooltip from '../app/design/Tooltip'

type LineItemDisplayDetails = {
    name: string
    imageUri?: string
    id: string
}

const extractLineItemDisplayDetails = (li: Line | Item): LineItemDisplayDetails => {
    if (li instanceof Item) {
        return {
            name: li.name ?? '',
            imageUri: li.image?.uri,
            id: li.id ?? '',
        }
    }

    return {
        name: li.itemDisplay ?? '',
        imageUri: li.item?.image?.uri,
        id: li.id ?? '',
    }
}

export function ServiceAlertSubtitle({ services }: { services: Item[] | Line[] }) {
    const { overflowing, ref } = useOverflowStatus()

    if (services.length === 0) return null

    if (services.length === 1) {
        const details = extractLineItemDisplayDetails(services[0])
        return (
            <Tooltip label={details.name} position="top" disabled={!overflowing} wrap>
                <p className="max-w-[180px] truncate text-paragraph-sm text-gray-600" ref={ref}>
                    {details.name}
                </p>
            </Tooltip>
        )
    }

    return (
        <Tooltip
            label={
                <div className="flex flex-col gap-1">
                    {services.map((s) => (
                        <Paragraph size="sm" key={s.id}>
                            {extractLineItemDisplayDetails(s).name}
                        </Paragraph>
                    ))}
                </div>
            }
            position="top"
            wrap
        >
            <p className="max-w-[180px] text-paragraph-sm text-gray-600" ref={ref}>
                {`${services.length} services`}
            </p>
        </Tooltip>
    )
}
